'use strict';



// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
            || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)        {
        window.requestAnimationFrame = function (callback) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function () {
                callback(currTime + timeToCall);
            },
            timeToCall);
            lastTime = currTime + timeToCall;

            return id;
        };
    }

    if (!window.cancelAnimationFrame)        {
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
    }
})();


module.exports = {
    blockScrollOnSwipe: function (el) {
        let x;
        let y;
        let scroll;

        const onTouchStart = function (e) {
            if (e.touches.length > 1) {
                return;
            }

            scroll = undefined;
            x = e.touches[0].pageX;
            y = e.touches[0].pageY;
        };

        const onTouchMove = function (e) {
            if (scroll === 'v') {
                return;
            }

            const dX = e.touches[0].pageX - x;
            const dY = e.touches[0].pageY - y;

            if (scroll === 'h') {
                e.preventDefault();
            } else if (Math.abs(dX) > 5 || Math.abs(dY) > 5) {
                scroll = Math.abs(dX) > Math.abs(dY) ? 'h' : 'v';
            }
        };

        el.addEventListener('touchstart', onTouchStart, {passive: false});
        el.addEventListener('touchmove', onTouchMove, {passive: false});
    },

/*eslint-disable */
    easingFunctions: function (st, ed, per, easing) {
        var functions = {
            //simple linear tweening - no easing, no acceleration
            linearTween: function (t, b, c, d) {
                return c * t / d + b;
            },

            // quadratic easing in - accelerating from zero velocity
            easeInQuad: function (t, b, c, d) {
                t /= d;

                return c * t * t + b;
            },

            // quadratic easing out - decelerating to zero velocity
            easeOutQuad: function (t, b, c, d) {
                t /= d;

                return -c * t * (t - 2) + b;
            },

            // quadratic easing in/out - acceleration until halfway, then deceleration
            easeInOutQuad: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * t * t + b;
                t--;

                return -c / 2 * (t * (t - 2) - 1) + b;
            },

            // cubic easing in - accelerating from zero velocity
            easeInCubic: function (t, b, c, d) {
                t /= d;

                return c * t * t * t + b;
            },

            // cubic easing out - decelerating to zero velocity
            easeOutCubic: function (t, b, c, d) {
                t /= d;
                t--;

                return c * (t * t * t + 1) + b;
            },

            // cubic easing in/out - acceleration until halfway, then deceleration
            easeInOutCubic: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * t * t * t + b;
                t -= 2;

                return c / 2 * (t * t * t + 2) + b;
            },

            // quartic easing in - accelerating from zero velocity
            easeInQuart: function (t, b, c, d) {
                t /= d;

                return c * t * t * t * t + b;
            },

            // quartic easing out - decelerating to zero velocity
            easeOutQuart: function (t, b, c, d) {
                t /= d;
                t--;

                return -c * (t * t * t * t - 1) + b;
            },

            // quartic easing in/out - acceleration until halfway, then deceleration
            easeInOutQuart: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * t * t * t * t + b;
                t -= 2;

                return -c / 2 * (t * t * t * t - 2) + b;
            },

            // quintic easing in - accelerating from zero velocity
            easeInQuint: function (t, b, c, d) {
                t /= d;

                return c * t * t * t * t * t + b;
            },

            // quintic easing out - decelerating to zero velocity
            easeOutQuint: function (t, b, c, d) {
                t /= d;
                t--;

                return c * (t * t * t * t * t + 1) + b;
            },

            // quintic easing in/out - acceleration until halfway, then deceleration
            easeInOutQuint: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * t * t * t * t * t + b;
                t -= 2;

                return c / 2 * (t * t * t * t * t + 2) + b;
            },

            // sinusoidal easing in - accelerating from zero velocity
            easeInSine: function (t, b, c, d) {
                return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
            },

            // sinusoidal easing out - decelerating to zero velocity
            easeOutSine: function (t, b, c, d) {
                return c * Math.sin(t / d * (Math.PI / 2)) + b;
            },

            // sinusoidal easing in/out - accelerating until halfway, then decelerating
            easeInOutSine: function (t, b, c, d) {
                return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
            },

            // exponential easing in - accelerating from zero velocity
            easeInExpo: function (t, b, c, d) {
                return c * Math.pow( 2, 10 * (t / d - 1) ) + b;
            },

            // exponential easing out - decelerating to zero velocity
            easeOutExpo: function (t, b, c, d) {
                return c * ( -Math.pow( 2, -10 * t / d ) + 1 ) + b;
            },

            // exponential easing in/out - accelerating until halfway, then decelerating
            easeInOutExpo: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * Math.pow( 2, 10 * (t - 1) ) + b;
                t--;

                return c / 2 * ( -Math.pow( 2, -10 * t) + 2 ) + b;
            },

            // circular easing in - accelerating from zero velocity
            easeInCirc: function (t, b, c, d) {
                t /= d;

                return -c * (Math.sqrt(1 - t * t) - 1) + b;
            },

            // circular easing out - decelerating to zero velocity
            easeOutCirc: function (t, b, c, d) {
                t /= d;
                t--;

                return c * Math.sqrt(1 - t * t) + b;
            },

            // circular easing in/out - acceleration until halfway, then deceleration
            easeInOutCirc: function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
                t -= 2;

                return c / 2 * (Math.sqrt(1 - t * t) + 1) + b;
            }
        };

        return functions[easing](per, st, ed - st, 1);
    }
    /*eslint-enable */

};
